/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Checkbox from '../Checkbox';

import RadioActive from '../../icons/RadioActive';


const RadioButton = ({ className, ...otherProps }) => (
  <Checkbox
    className={classnames(className, 'p-round')}
    CheckboxComponent={RadioActive}
    {...otherProps}
  />
);

RadioButton.defaultProps = {
  className: null,
};

RadioButton.propTypes = {
  className: PropTypes.string,
};

export default RadioButton;
